import React from 'react';
import styles from './FloatingApplyButton.module.css';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
/**
 * Component nút "Ứng tuyển ngay" nổi ở cuối màn hình (mobile/tablet)
 * @param {boolean} isVisible - Hiển thị hay ẩn nút
 * @param {Function} onClick - Callback khi click nút
 */
export default function FloatingApplyButton({isVisible, onClick}) {
    if (!isVisible) return null;
    const {locale} = useRouter();
    const handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    };

    return (
        <button className={styles.floatingBtn} onClick={handleClick}>
            {getLocaleContent(locale, 'page.recruitment.join_us_now')}
        </button>
    );
}
